/* global $:false */

export default class MegaMenu {
  static init () {
    Array.from($('.js-megamenu')).map((el) =>
      new MegaMenu(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
    this.setInitialSize()
    this.animateWhenScrolling()
  }

  findElements () {
    this.sigill = this.el.find('.js-topmenu__sigill')
    this.logo = this.el.find('.js-topmenu__logo')
    this.contactLink = this.el.find('.js-topmenu__contact-trigger')
    this.contactContainer = this.el.find('.js-topmenu__contact')

    this.hammerLink = this.el.find('.js-menu__heading--hammer')
    this.onlineLink = this.el.find('.js-menu__heading--online')
    this.hammerContainer = this.el.find('.js-menu__hammer')
    this.onlineContainer = this.el.find('.js-menu__online')
  }

  setupBindings () {
    this.contactLink.click(e => {
      e.preventDefault()
      const openMe = !this.contactContainer.is(':visible')
      this.closeAll()
      if (openMe) {
        $(e.target).addClass('selected')
        this.contactContainer.show()
      }
    })

    this.hammerLink.click(e => {
      e.preventDefault()
      const openMe = !this.hammerContainer.is(':visible')
      this.closeAll()
      if (openMe) {
        $(e.target).addClass('selected')
        this.hammerContainer.show()
      }
    })

    this.onlineLink.click(e => {
      e.preventDefault()
      const openMe = !this.onlineContainer.is(':visible')
      this.closeAll()
      if (openMe) {
        $(e.target).addClass('selected')
        this.onlineContainer.show()
      }
    })
  }

  closeAll () {
    this.hammerLink.removeClass('selected')
    this.onlineLink.removeClass('selected')
    this.contactContainer.hide()
    this.hammerContainer.hide()
    this.onlineContainer.hide()
  }

  setInitialSize () {
    $(() => {
      this.logo.data('size', 'big')
      this.sigill.data('size', 'big')
    })
  }

  animateWhenScrolling () {
    $(window).scroll(() => {
      if ($(document).scrollTop() > 0) {
        if ((this.logo.data('size') === 'big') || (this.sigill.data('size') === 'big')) {
          this.logo.data('size', 'small')
          this.sigill.data('size', 'small')
          this.logo.stop().animate({ height: '40px' }, 400)
          this.sigill.stop().animate({ height: '85px', 'margin-top': '0.1em', 'margin-bottom': '0.1em' }, 400)
        }
      } else {
        this.logo.data('size', 'big')
        this.sigill.data('size', 'big')
        this.logo.stop().animate({ height: '100px' }, 400)
        this.sigill.stop().animate({ height: '150px', 'margin-top': '0.5em', 'margin-bottom': '0.5em' }, 400)
      }
    })
  }
}
